module.exports = __webpack_public_path__ + "img/logo_bai.7ba768fc.png";